import _typeof from "@babel/runtime/helpers/typeof";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import config from 'config';
import { createFetch, defaultRetryMethods, isJsonContentType, isFetchError } from './fetch';
import initializeSessionToken from './initializeSessionToken';
import logger from './logger';
import { matchCookieDomain } from './utils';
var debug = logger.extend('bentoApiClient');
/**
 * Return a function that will retrieve either a `public.bentoApi` or
 * `server.bentoApi` config key depending on whether `isServer` is true. If
 * there is no server-specific value, the public value will be used.
 */

function getEnvConfig(isServer) {
  return function (key) {
    var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var publicKey = "public.bentoApi.".concat(key);

    if (isServer) {
      var serverKey = "server.bentoApi.".concat(key);

      if (config.has(serverKey)) {
        return config.get(serverKey);
      }
    }

    if (!isRequired && !config.has(publicKey)) {
      return undefined;
    }

    return config.get(publicKey);
  };
}

var bentoRetryPresets = new Map([[502, 'default'], [503, 'default'], [504, 'default'], [421, 'throttled'], [429, 'throttled']]);
var ErrorCodes = {
  STORE_NOT_FOUND: -32001,
  INVALID_PARAMS: -32022,
  ORDER_NOT_FOUND: -32080
};
var EchoCartErrorCodes = {
  NO_INVENTORY: 120
};

function getErrorCodes(_x) {
  return _getErrorCodes.apply(this, arguments);
}

function _getErrorCodes() {
  _getErrorCodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var clonedResponse, payload, errorCodes, addError;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            clonedResponse = response.clone();
            _context.next = 4;
            return clonedResponse.json();

          case 4:
            payload = _context.sent;
            errorCodes = [];

            addError = function addError(error, payload) {
              var message = payload.message;

              if (error && _typeof(error) === 'object' && typeof error.code === 'number') {
                var _message$includes;

                var isEchoCartError = (_message$includes = message === null || message === void 0 ? void 0 : message.includes('echoServiceCart')) !== null && _message$includes !== void 0 ? _message$includes : false;
                errorCodes.push({
                  isEchoCartError: isEchoCartError,
                  code: error.code
                });
              }
            };

            if (payload.error) {
              addError(payload.error, payload);
            }

            if (payload.errors) {
              payload.errors.forEach(function (error) {
                return addError(error, payload);
              });
            }

            return _context.abrupt("return", errorCodes);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", []);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
  return _getErrorCodes.apply(this, arguments);
}

export function bentoRetryPolicy(_x2, _x3, _x4, _x5) {
  return _bentoRetryPolicy.apply(this, arguments);
} // FIXME: Bento REST API sometimes returns a 200 OK response, but then includes
// additional information in the body like `status: 502` or an `errors` array.
// This makes sure responses with a `status` >=400 throw errors.

function _bentoRetryPolicy() {
  _bentoRetryPolicy = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(err, response, input, options) {
    var _options$log, log, errors, _iterator, _step, error, isEchoCartError, code;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!err) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return", isFetchError(err) && defaultRetryMethods.has(options.method) ? 'default' : false);

          case 2:
            if (!(response.status === 502)) {
              _context2.next = 36;
              break;
            }

            _options$log = options.log, log = _options$log === void 0 ? debug : _options$log; // Some 502 errors should actually be 400-level errors because they indicate
            // a bad request. Try to detect those here.
            // TODO: Make sure we have a TRO ticket request for making these the correct
            // status code.

            _context2.next = 6;
            return getErrorCodes(response);

          case 6:
            errors = _context2.sent;
            _iterator = _createForOfIteratorHelper(errors);
            _context2.prev = 8;

            _iterator.s();

          case 10:
            if ((_step = _iterator.n()).done) {
              _context2.next = 28;
              break;
            }

            error = _step.value;
            isEchoCartError = error.isEchoCartError, code = error.code;

            if (!isEchoCartError) {
              _context2.next = 21;
              break;
            }

            _context2.t0 = code;
            _context2.next = _context2.t0 === EchoCartErrorCodes.NO_INVENTORY ? 17 : 19;
            break;

          case 17:
            log('Detected error code %s in response; disabling retry.', code);
            return _context2.abrupt("return", false);

          case 19:
            _context2.next = 26;
            break;

          case 21:
            _context2.t1 = code;
            _context2.next = _context2.t1 === ErrorCodes.INVALID_PARAMS ? 24 : _context2.t1 === ErrorCodes.STORE_NOT_FOUND ? 24 : _context2.t1 === ErrorCodes.ORDER_NOT_FOUND ? 24 : 26;
            break;

          case 24:
            log('Detected error code %s in response; disabling retry.', code);
            return _context2.abrupt("return", false);

          case 26:
            _context2.next = 10;
            break;

          case 28:
            _context2.next = 33;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t2 = _context2["catch"](8);

            _iterator.e(_context2.t2);

          case 33:
            _context2.prev = 33;

            _iterator.f();

            return _context2.finish(33);

          case 36:
            return _context2.abrupt("return", bentoRetryPresets.get(response.status) || false);

          case 37:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[8, 30, 33, 36]]);
  }));
  return _bentoRetryPolicy.apply(this, arguments);
}

function fixErrorResponse(_x6, _x7, _x8) {
  return _fixErrorResponse.apply(this, arguments);
}

function _fixErrorResponse() {
  _fixErrorResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(response, input, options) {
    var body, payload, _options$log2, log;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!(response.status === 200 && isJsonContentType(response))) {
              _context3.next = 12;
              break;
            }

            _context3.next = 3;
            return response.text();

          case 3:
            body = _context3.sent;
            payload = JSON.parse(body);

            if (!(payload && _typeof(payload) === 'object' && typeof payload.status === 'number' && payload.status >= 400)) {
              _context3.next = 11;
              break;
            }

            _options$log2 = options.log, log = _options$log2 === void 0 ? debug : _options$log2;
            log('%c!%c Received HTTP 200 response with an error payload (status: %s); a fixed Response instance will be created. Notify the Bento API team about this discrepancy!', 'color: yellow', '', payload.status);
            return _context3.abrupt("return", new Response(body, {
              status: payload.status,
              // Don't include `statusText` because remember, the `response.status`
              // wasn't accurate!
              headers: response.headers
            }));

          case 11:
            return _context3.abrupt("return", new Response(body, {
              status: response.status,
              statusText: response.statusText,
              headers: response.headers
            }));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fixErrorResponse.apply(this, arguments);
}

export default function createBentoApiClient(options) {
  var _req$context, _req$context$bentoApi, _req$context2, _req$context2$bentoAp, _req$context3, _req$context3$bentoAp, _req$context4, _req$context4$bentoAp;

  var storeDomain = options.storeDomain,
      req = options.req,
      isServer = options.isServer,
      trueClientIp = options.trueClientIp,
      _options$readSessionT = options.readSessionToken,
      readSessionToken = _options$readSessionT === void 0 ? req === null || req === void 0 ? void 0 : req.context.readSessionToken : _options$readSessionT,
      _options$updateSessio = options.updateSessionToken,
      updateSessionToken = _options$updateSessio === void 0 ? req === null || req === void 0 ? void 0 : req.context.updateSessionToken : _options$updateSessio,
      isUnsafeAuth = options.isUnsafeAuth,
      isContentPreview = options.isContentPreview,
      secondarySite = options.secondarySite; // Helper for retrieving public or server specific config.

  var configGet = getEnvConfig(isServer);
  var prefixUrl = configGet('gateway');
  var apiKey = configGet(secondarySite ? "secondarySiteKeys.".concat(secondarySite) : 'key');
  var apiKeyHeader = configGet('keyHeader');
  var gatewayToken = configGet('gatewayToken', false);
  var sessionCookie = configGet('sessionCookie');
  var timeout = configGet('timeout', false);

  var headers = _defineProperty({
    'Content-Type': 'application/json',
    'x-tfg-storeDomain': storeDomain
  }, apiKeyHeader, apiKey);

  if (gatewayToken) {
    headers['x-gateway-token'] = gatewayToken;
  }

  if (trueClientIp) {
    headers['True-Client-IP'] = trueClientIp;
  }

  if (req !== null && req !== void 0 && (_req$context = req.context) !== null && _req$context !== void 0 && (_req$context$bentoApi = _req$context.bentoApi) !== null && _req$context$bentoApi !== void 0 && _req$context$bentoApi.enableContentPreview && req !== null && req !== void 0 && (_req$context2 = req.context) !== null && _req$context2 !== void 0 && (_req$context2$bentoAp = _req$context2.bentoApi) !== null && _req$context2$bentoAp !== void 0 && _req$context2$bentoAp.enableContentPreview(req) || isContentPreview) {
    headers['x-tfg-content-preview'] = 'true';
  }

  var hooks = {
    beforeRequest: [],
    afterResponse: []
  };
  hooks.afterResponse.push(fixErrorResponse); // The browser will automatically manage cookies, including attaching them to
  // requests, whereas the server needs to do this manually. In order to avoid
  // complicating cookie parsing and management libraries, the server uses the
  // `Authorization` header instead, which is much simpler.
  // NOTE! A client can be created without necessarily having a `req` due to
  // features like rewrites, which load the endpoint before a request comes
  // in.

  if (!process.browser || isUnsafeAuth) {
    if (req) {
      // If the token was already initialized elsewhere, this will do nothing.
      initializeSessionToken({
        req: req,
        readSessionToken: readSessionToken,
        updateSessionToken: updateSessionToken
      });
    }

    hooks.beforeRequest.push(function (input, options) {
      if (readSessionToken) {
        var sessionToken = readSessionToken();

        if (sessionToken) {
          options.headers.set('Authorization', "Bearer ".concat(sessionToken));
        }
      }

      if (req) {
        var origin = req.get('Origin');

        if (origin) {
          options.headers.set('Origin', origin);
        }
      }
    });
    hooks.afterResponse.push(function (response) {
      var _response$headers;

      // Remember what we said above about using the Authorization header to
      // avoid cookie complications? Well, the API doesn't always send a new
      // `Authorization` header when the token is updated, but it does send
      // `Set-Cookie`. So we need to deal with cookies anyway.
      var setCookies = response === null || response === void 0 ? void 0 : (_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get('Set-Cookie');

      if (!setCookies) {
        return;
      }

      var setCookieParser = require('set-cookie-parser');

      var cookies = setCookieParser.parse(setCookies);
      cookies.forEach(function (_ref) {
        var cookie = _extends({}, _ref);

        if (cookie.name === sessionCookie && readSessionToken && updateSessionToken) {
          var newToken = cookie.value;
          var currentToken = readSessionToken();

          if (newToken !== currentToken) {
            debug('Received new session token via Set-Cookie header.');
            updateSessionToken(newToken);
          }
        }

        if (req && !req.context.anonymousServerSession) {
          var requestDomain = req.context.url.hostname;

          if (cookie.domain && !matchCookieDomain(cookie.domain, requestDomain)) {
            debug('Set-Cookie domain does not match request domain: %s vs. %s. Rewriting cookie without domain.', cookie.domain, requestDomain);
            cookie.domain = undefined;
          } // `reduxExtension` will take care of adding this to the response.
          // We don't want to call `res.cookie` every time we receive one in
          // an API response because there could be multiple, resulting in
          // multiple `Set-Cookie` headers for the same cookie.


          req.context.setCookies.set(cookie.name, cookie);
        }
      });
    });
  }

  if (typeof (req === null || req === void 0 ? void 0 : (_req$context3 = req.context) === null || _req$context3 === void 0 ? void 0 : (_req$context3$bentoAp = _req$context3.bentoApi) === null || _req$context3$bentoAp === void 0 ? void 0 : _req$context3$bentoAp.beforeRequestHooks) === 'function') {
    var _hooks$beforeRequest;

    (_hooks$beforeRequest = hooks.beforeRequest).push.apply(_hooks$beforeRequest, _toConsumableArray(req.context.bentoApi.beforeRequestHooks));
  }

  if (typeof (req === null || req === void 0 ? void 0 : (_req$context4 = req.context) === null || _req$context4 === void 0 ? void 0 : (_req$context4$bentoAp = _req$context4.bentoApi) === null || _req$context4$bentoAp === void 0 ? void 0 : _req$context4$bentoAp.afterResponseHooks) === 'function') {
    var _hooks$afterResponse;

    (_hooks$afterResponse = hooks.afterResponse).push.apply(_hooks$afterResponse, _toConsumableArray(req.context.bentoApi.afterResponseHooks));
  }

  var client = createFetch({
    headers: headers,
    har: req && req.context.har ? req.context.har : false,
    hooks: hooks,
    prefixUrl: prefixUrl,
    retry: bentoRetryPolicy,
    timeout: timeout
  });
  return client;
}